/**
 * Lightweight (no-dependency) detection for Excel-style spreadsheets.
 *
 * Kept separate from `ExcelPreview` so callers that only need to know "is this
 * a spreadsheet?" (e.g. picking an icon) don't pull the heavy `xlsx` parser
 * and AG Grid into their bundle — only the actual renderer does.
 *
 * Some backends hand back a generic `application/octet-stream` content type for
 * uploaded files, so the extension check is the reliable fallback — that's why
 * this also looks at the display name.
 */
const SPREADSHEET_CONTENT_TYPES = new Set([
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "application/vnd.ms-excel.sheet.macroEnabled.12", // .xlsm
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12", // .xlsb
]);

const SPREADSHEET_EXTENSIONS = /\.(xlsx|xls|xlsm|xlsb)$/i;

/**
 * Whether a loan document should be rendered with the Excel workbook viewer.
 * Pass the file's `content_type` and its display name (the extension is the
 * dependable signal when the content type is missing or generic).
 */
export const isSpreadsheetFile = ({ content_type, fileName } = {}) => {
  if (content_type && SPREADSHEET_CONTENT_TYPES.has(content_type)) return true;
  if (fileName && SPREADSHEET_EXTENSIONS.test(fileName.trim())) return true;
  return false;
};

export default isSpreadsheetFile;
